<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="6">
          <div>
            <p>Copy Keyword search and phrases</p>
            <b-input-group class="mt-3">
              <template v-slot:prepend>
                <b-button
                  :disabled="searchPage"
                  variant="outline-warning"
                  @click="copyAllKeyWords"
                  style="height:35px;"
                >Add All</b-button>
              </template>
              <v-select
                id="additionalKeyword"
                size="sm"
                :searchable="true"
                :clearable="true"
                :multiple="true"
                label="text"
                :disabled="searchPage"
                v-model="selectAdditionalKeywordPhrases"
                :options="additionalKeywordPhrasesList"
                style="width: 72%;"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                    @focus="copyAdditionalKeywordPhrases()"
                  />
                </template>
              </v-select>
              <b-input-group-append>
                <b-button
                  :disabled="searchPage"
                  variant="outline-warning"
                  @click="pasteAdditionalKeywordPhrases"
                  style="height:35px;"
                >Add</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
          <div class="mt-3">
            <p>Add Keyword search and phrases From Other Pri's</p>
            <b-input-group class="mt-3">
              <template v-slot:prepend>
                <b-button
                  variant="outline-warning"
                  :disabled="searchPage"
                  @click="copyAllKeyWordsFromOtherPri"
                  style="height:35px;"
                >Add All</b-button>
              </template>
              <v-select
                id="additionalKeyword"
                size="sm"
                :searchable="true"
                :clearable="true"
                :multiple="true"
                label="text"
                :disabled="searchPage"
                v-model="selectAdditionalKeywordPhrasesFromOtherPri"
                :options="uniqPriConfigrationKeywordsData"
                style="width: 72%;"
              ></v-select>
              <b-input-group-append>
                <b-button
                  variant="outline-warning"
                  :disabled="searchPage"
                  @click="pasteAdditionalKeywordPhrasesFromOtherPri"
                  style="height:35px;"
                >Add</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
          <h4 class="mt-3 text-left">Keyword search and phrases</h4>
          <b-input-group class="mt-3">
            <b-form-input
              :disabled="searchPage"
              placeholder="Enter the entity name you would like to search..."
              @keyup.enter="addAdditionalKeywordPhrases()"
              v-model="addKeyWord"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                :disabled="searchPage"
                @click="addAdditionalKeywordPhrases"
                variant="outline-warning"
              >Add</b-button>
            </b-input-group-append>
          </b-input-group>

          <b-table
            :items="futureRiskTab ? $store.state.priConfigrationforms.futureRisks.categories[categoriesIndex].searchKeywords : $store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].searchKeywords"
            :fields="fieldsKeywords"
          >
            <template v-slot:cell(text)="data">
              <p>{{data.item}}</p>
            </template>
            <template v-slot:cell(actions)="data">
              <b-button
                :disabled="searchPage"
                @click="removeAdditionalKeywordPhrases(data)"
                variant="danger"
                size="sm"
              >
                <font-awesome-icon icon="trash"></font-awesome-icon>
              </b-button>
            </template>
          </b-table>
        </b-col>
        <b-col cols="6">
          <div>
            <p>Copy Exclude Keyword search and phrases</p>
            <b-input-group class="mt-3">
              <template v-slot:prepend>
                <b-button
                  variant="outline-warning"
                  :disabled="searchPage"
                  @click="copyAllKeyWordsPhrases"
                  style="height:35px;"
                >Add All</b-button>
              </template>
              <v-select
                size="sm"
                :searchable="true"
                :clearable="true"
                :multiple="true"
                label="text"
                :disabled="searchPage"
                v-model="selectAdditionalExcludeKeywordPhrases"
                :options="additionalExcludeKeywordPhrasesList"
                style="width: 72%;"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    v-bind="attributes"
                    v-on="events"
                    @focus="copyAdditionalExcludeKeywordPhrases()"
                  />
                </template>
              </v-select>
              <b-input-group-append>
                <b-button
                  variant="outline-warning"
                  :disabled="searchPage"
                  @click="pasteAdditionalExcludeKeywordPhrases"
                  style="height:35px;"
                >Add</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
          <div class="mt-3">
            <p>Add Exclude Keyword search and phrases From Other Pri's</p>
            <b-input-group class="mt-3">
              <template v-slot:prepend>
                <b-button
                  variant="outline-warning"
                  :disabled="searchPage"
                  @click="copyAllKeyWordsPhrasesFromOtherPri"
                  style="height:35px;"
                >Add All</b-button>
              </template>
              <v-select
                size="sm"
                :searchable="true"
                :clearable="true"
                :multiple="true"
                label="text"
                :disabled="searchPage"
                v-model="selectAdditionalExcludeKeywordPhrasesFromOtherPri"
                :options="uniqPriConfigrationExcludeKeywordsData"
                style="width: 72%;"
              ></v-select>
              <b-input-group-append>
                <b-button
                  variant="outline-warning"
                  :disabled="searchPage"
                  @click="pasteAdditionalExcludeKeywordPhrasesFromOtherPri"
                  style="height:35px;"
                >Add</b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
          <h4 class="mt-3 text-left">Exclude Keyword search and phrases</h4>
          <b-input-group class="mt-3">
            <b-form-input
              :disabled="searchPage"
              placeholder="Enter the entity name you would like to search..."
              @keyup.enter="addAdditionalExcludeKeywordPhrases()"
              v-model="excludeTerm"
            ></b-form-input>
            <b-input-group-append>
              <b-button
                :disabled="searchPage"
                @click="addAdditionalExcludeKeywordPhrases"
                variant="outline-warning"
              >Add</b-button>
            </b-input-group-append>
          </b-input-group>

          <b-table
            :items="futureRiskTab ? $store.state.priConfigrationforms.futureRisks.categories[categoriesIndex].searchExcludeKeywords : $store.state.priConfigrationforms.negativeMedia.categories[categoriesIndex].searchExcludeKeywords"
            :fields="fieldsKeywords"
          >
            <template v-slot:cell(text)="data">
              <p>{{data.item}}</p>
            </template>
            <template v-slot:cell(actions)="data">
              <b-button
                :disabled="searchPage"
                @click="removeAdditionalExcludeKeywordPhrases(data)"
                variant="danger"
                size="sm"
              >
                <font-awesome-icon icon="trash"></font-awesome-icon>
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  name: "KeywordComponent",
  data() {
    return {
      additionalKeywordPhrasesList: [],
      selectAdditionalKeywordPhrases: [],
      selectAdditionalKeywordPhrasesFromOtherPri: [],
      selectAdditionalExcludeKeywordPhrasesFromOtherPri: [],
      selectAdditionalExcludeKeywordPhrases: [],
      additionalExcludeKeywordPhrasesList: [],
      addKeyWord: null,
      fieldsKeywords: [
        { key: "text", label: "Keyword" },
        { key: "Actions", label: "Actions" }
      ],
      excludeTerm: null,
      uniqPriConfigrationExcludeKeywordsData: [],
      uniqPriConfigrationKeywordsData: []
    };
  },
  mounted() {
    this.uniqPriConfigrationKeywordsData = _.uniq(
      this.priConfigrationKeywordsData
    );
    this.uniqPriConfigrationExcludeKeywordsData = _.uniq(
      this.priConfigrationExcludeKeywordsData
    );
  },
  methods: {
    copyAdditionalKeywordPhrases() {
      // console.log("copyAdditionalKeywordPhrases");
      this.additionalKeywordPhrasesList = [];
      if (
        this.$store.state.priConfigrationforms.futureRisks.categories.length > 0
      ) {
        this.$store.state.priConfigrationforms.futureRisks.categories.map(
          futureRisksCategoriesData => {
            futureRisksCategoriesData.searchKeywords.map(searchKeywordsData => {
              this.additionalKeywordPhrasesList.push({
                text: searchKeywordsData,
                value: searchKeywordsData
              });
            });
          }
        );
      }
      if (
        this.$store.state.priConfigrationforms.negativeMedia.categories.length >
        0
      ) {
        this.$store.state.priConfigrationforms.negativeMedia.categories.map(
          negativeMediaCategoriesData => {
            negativeMediaCategoriesData.searchKeywords.map(
              searchKeywordsData => {
                this.additionalKeywordPhrasesList.push({
                  text: searchKeywordsData,
                  value: searchKeywordsData
                });
              }
            );
          }
        );
      }
    },
    copyAllKeyWords() {
      let keywodsData = [];
      this.$store.state.priConfigrationforms.negativeMedia.categories.map(
        negativeMediaCategoriesData => {
          negativeMediaCategoriesData.searchKeywords.map(searchKeywordsData => {
            keywodsData.push(searchKeywordsData);
          });
        }
      );
      this.$store.state.priConfigrationforms.futureRisks.categories.map(
        futureRisksCategoriesData => {
          futureRisksCategoriesData.searchKeywords.map(searchKeywordsData => {
            keywodsData.push(searchKeywordsData);
          });
        }
      );

      keywodsData.map(value => {
        if (this.futureRiskTab) {
          this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].searchKeywords.unshift(value);
        } else {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].searchKeywords.unshift(value);
        }
      });
    },
    pasteAdditionalKeywordPhrases() {
      this.selectAdditionalKeywordPhrases.map(value => {
        if (this.futureRiskTab) {
          this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].searchKeywords.unshift(value.text);
        } else {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].searchKeywords.unshift(value.text);
        }
      });
      this.additionalKeywordPhrasesList = [];
      this.selectAdditionalKeywordPhrases = [];
    },
    pasteAdditionalKeywordPhrasesFromOtherPri() {
      this.selectAdditionalKeywordPhrasesFromOtherPri.map(value => {
        if (this.futureRiskTab) {
          this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].searchKeywords.unshift(value);
        } else {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].searchKeywords.unshift(value);
        }
      });
      this.selectAdditionalKeywordPhrasesFromOtherPri = [];
    },
    copyAllKeyWordsFromOtherPri() {
      this.uniqPriConfigrationKeywordsData.map(data => {
        if (this.futureRiskTab) {
          this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].searchKeywords.unshift(data);
        } else {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].searchKeywords.unshift(data);
        }
      });
    },
    copyAdditionalExcludeKeywordPhrases() {
      this.additionalExcludeKeywordPhrasesList = [];
      if (
        this.$store.state.priConfigrationforms.futureRisks.categories.length > 0
      ) {
        this.$store.state.priConfigrationforms.futureRisks.categories.map(
          futureRisksCategoriesData => {
            futureRisksCategoriesData.searchExcludeKeywords.map(
              searchExcludeKeywordsData => {
                this.additionalExcludeKeywordPhrasesList.push({
                  text: searchExcludeKeywordsData,
                  value: searchExcludeKeywordsData
                });
              }
            );
          }
        );
      }
      if (
        this.$store.state.priConfigrationforms.negativeMedia.categories.length >
        0
      ) {
        this.$store.state.priConfigrationforms.negativeMedia.categories.map(
          negativeMediaCategoriesData => {
            negativeMediaCategoriesData.searchExcludeKeywords.map(
              searchExcludeKeywordsData => {
                this.additionalExcludeKeywordPhrasesList.push({
                  text: searchExcludeKeywordsData,
                  value: searchExcludeKeywordsData
                });
              }
            );
          }
        );
      }
    },
    copyAllKeyWordsPhrases() {
      let keywodsPhrasesData = [];
      this.$store.state.priConfigrationforms.negativeMedia.categories.map(
        negativeMediaCategoriesData => {
          negativeMediaCategoriesData.searchExcludeKeywords.map(
            searchExcludeKeywordsData => {
              keywodsPhrasesData.push(searchExcludeKeywordsData);
            }
          );
        }
      );
      this.$store.state.priConfigrationforms.futureRisks.categories.map(
        futureRisksCategoriesData => {
          futureRisksCategoriesData.searchExcludeKeywords.map(
            searchExcludeKeywordsData => {
              keywodsPhrasesData.push(searchExcludeKeywordsData);
            }
          );
        }
      );

      keywodsPhrasesData.map(value => {
        if (this.futureRiskTab) {
          this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].searchExcludeKeywords.unshift(value);
        } else {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].searchExcludeKeywords.unshift(value);
        }
      });
    },
    pasteAdditionalExcludeKeywordPhrases() {
      this.selectAdditionalExcludeKeywordPhrases.map(value => {
        if (this.futureRiskTab) {
          this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].searchExcludeKeywords.unshift(value.text);
        } else {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].searchExcludeKeywords.unshift(value.text);
        }
      });
      this.additionalExcludeKeywordPhrasesList = [];
      this.selectAdditionalExcludeKeywordPhrases = [];
    },

    pasteAdditionalExcludeKeywordPhrasesFromOtherPri() {
      this.selectAdditionalExcludeKeywordPhrasesFromOtherPri.map(value => {
        if (this.futureRiskTab) {
          this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].searchExcludeKeywords.unshift(value);
        } else {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].searchExcludeKeywords.unshift(value);
        }
      });
      this.selectAdditionalExcludeKeywordPhrasesFromOtherPri = [];
    },

    copyAllKeyWordsPhrasesFromOtherPri() {
      this.uniqPriConfigrationExcludeKeywordsData.map(data => {
        if (this.futureRiskTab) {
          this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].searchExcludeKeywords.unshift(data);
        } else {
          this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].searchExcludeKeywords.unshift(data);
        }
      });
    },

    addAdditionalKeywordPhrases() {
      if (this.addKeyWord) {
        let searchKeywordData = this.futureRiskTab
          ? this.$store.state.priConfigrationforms.futureRisks.categories[
              this.categoriesIndex
            ].searchKeywords
          : this.$store.state.priConfigrationforms.negativeMedia.categories[
              this.categoriesIndex
            ].searchKeywords;
        searchKeywordData.unshift(this.addKeyWord);
      }

      this.addKeyWord = null;
    },

    removeAdditionalKeywordPhrases(data) {
      let searchKeywordData = this.futureRiskTab
        ? this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].searchKeywords
        : this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].searchKeywords;
      let keywordPhrasesIndex = searchKeywordData.indexOf(data.item);
      searchKeywordData.splice(keywordPhrasesIndex, 1);
    },

    addAdditionalExcludeKeywordPhrases() {
      if (this.excludeTerm) {
        let searchExcludeKeywordsData = this.futureRiskTab
          ? this.$store.state.priConfigrationforms.futureRisks.categories[
              this.categoriesIndex
            ].searchExcludeKeywords
          : this.$store.state.priConfigrationforms.negativeMedia.categories[
              this.categoriesIndex
            ].searchExcludeKeywords;
        searchExcludeKeywordsData.unshift(this.excludeTerm);
      }

      this.excludeTerm = null;
    },

    removeAdditionalExcludeKeywordPhrases(data) {
      let searchExcludeKeywordsData = this.futureRiskTab
        ? this.$store.state.priConfigrationforms.futureRisks.categories[
            this.categoriesIndex
          ].searchExcludeKeywords
        : this.$store.state.priConfigrationforms.negativeMedia.categories[
            this.categoriesIndex
          ].searchExcludeKeywords;
      let keywordExcludePhrasesIndex = searchExcludeKeywordsData.indexOf(
        data.item
      );
      searchExcludeKeywordsData.splice(keywordExcludePhrasesIndex, 1);
    }
  },
  props: {
    futureRiskTab: Boolean,
    negativeMediaTab: Boolean,
    categoriesIndex: Number,
    negativeMediaEdit: Boolean,
    futureRisksEdit: Boolean,
    searchPage: Boolean,
    priConfigrationKeywordsData: Array,
    priConfigrationExcludeKeywordsData: Array
  }
};
</script>